export enum EDivisions {
    administrative = 'administrative',
    municipal = 'municipal',
}
